import { rankWith, uiTypeIs, LayoutProps } from '@jsonforms/core';
import {
  ResolvedJsonFormsDispatch,
  withJsonFormsLayoutProps,
} from '@jsonforms/react';
import { getElements } from '../../../../../utils/DynamicForms';

import './style.scss';

type Props = LayoutProps; // use correct prop type

const VerticalLayout = (props: Props) => {
  // console.log('Layout > Vertical Inputs', props);

  return (
    <div className="tru-layout-vertical-inputs">
      {getElements(props.uischema).map((element, index) => (
        <ResolvedJsonFormsDispatch {...props} uischema={element} key={index} />
      ))}
    </div>
  );
};

export const VerticalLayoutEntry = {
  tester: rankWith(1, uiTypeIs('VerticalLayout')),
  renderer: withJsonFormsLayoutProps(VerticalLayout),
};
